import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { DropdownList } from '@/js/libs/ui/src/V2';
export const PlaceholdersDropdownItem = ({ item, onClick }) => {
    const handleClick = useCallbackRef(() => {
        onClick(item);
    });
    return (_jsx(DropdownList.DropdownItem, { onClick: handleClick, dataTestId: `placeholder-${item}`, children: item }));
};
